import { DiscordIcon, GalxeIcon, GithubIcon, TwitterIcon, ZealyIcon } from "../components";

export const socialList = [
  {
    src: TwitterIcon,
    to: "https://twitter.com/DackieSwap",
    title: "twitter",
  },
  {
    src: DiscordIcon,
    to: "https://discord.gg/dackie",
    title: "discord",
  },
  {
    src: ZealyIcon,
    to: "https://zealy.io/c/dackieswap",
    title: "zealy",
  },
  {
    src: GalxeIcon,
    to: "https://galxe.com/Dackie/campaigns",
    title: "galxe",
  },
  {
    src: GithubIcon,
    to: "https://github.com/DackieSwap",
    title: "github",
  },
];
